import { useState } from 'react';
import useGetSharedFuelValues from '/business/shared/components/questions/_util_hooks/useGetSharedFuelValues';
import type { FuelType } from '/business/shared/components/questions/_util_hooks/useGetSharedFuelValues';

interface SharedFuelSchemaProps {
  buildingFuelTypes: FuelType[];
  hasAnswer?: boolean;
}

export default function useOnSitePowerGenerationSchema({ buildingFuelTypes: fuelTypes }: SharedFuelSchemaProps) {
  const [forceSubmitForm, setForceSubmitForm] = useState(false);
  const [valueFuelType, setValueFuelType] = useState<string | null>(null);

  const { pageSchema } = useGetSharedFuelValues({
    fuelTypes,
    valueFuelType,
    setValueFuelType,
  });

  return {
    pageSchema,
    forceSubmitForm,
    setForceSubmitForm,
  };
}
